module.exports = __webpack_public_path__ + "static/lexikon-56b9fa672d6fdbfa45fe9b362cd2db6d.png";